import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { AddchartRounded } from '@mui/icons-material';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';
import { useAndieChatControls } from '@/providers/andie-chat-provider';

type ActionResponse = { id: string; name: string };
type ActionArgs = { name?: string };

export type AndieCreateDashboardFromTemplateProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieCreateDashboardFromTemplate = (props: AndieCreateDashboardFromTemplateProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { agentNavigationPendingRef } = useAndieChatControls();
    const executingSteps = useRef<number>(0);

    useEffect(() => {
        if (props.status === ActionResponseStatusAi.EXECUTING) {
            executingSteps.current += 1;
        }

        if (
            props.status === ActionResponseStatusAi.COMPLETE &&
            props.result?.id &&
            executingSteps.current > 0
        ) {
            agentNavigationPendingRef.current = true;
            navigate('/dashboards/' + props.result.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.create-dashboard-from-template.title')}
            icon={<AddchartRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.create-dashboard-from-template.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.create-dashboard-from-template.complete', {
                    name: result?.name || '',
                })
            }
            {...props}
        />
    );
};

export default AndieCreateDashboardFromTemplate;
